import { handleErrors } from './ErrorActions';
import * as globalSearchApi from '../api/global-search';

export const CLEAR_TOP_MENU_MODAL = 'CLEAR_TOP_MENU_MODAL';
export const CLOSE_TOP_MENU_MODAL = 'CLOSE_TOP_MENU_MODAL';
export const FETCH_MENU_OPTIONS = 'TopMenuActions/FETCH_MENU_OPTIONS';
export const FETCH_MENU_OPTIONS_SUCCESS = 'TopMenuActions/FETCH_MENU_OPTIONS_SUCCESS';
export const FETCH_MENU_OPTIONS_FAILURE = 'TopMenuActions/FETCH_MENU_OPTIONS_FAILURE';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_SEARCH_OPTIONS = 'SET_SEARCH_OPTIONS';
export const SET_CLEAR_OPTIONS = 'SET_CLEAR_OPTIONS';

export const closeTopMenuModal = () => ({
  type: CLOSE_TOP_MENU_MODAL,
});

export const clearTopMenuModal = () => ({
  type: CLEAR_TOP_MENU_MODAL,
});

const fetchMenuOptionsSuccess = (menuOptions) => ({
  type: FETCH_MENU_OPTIONS_SUCCESS,
  menuOptions,
});

const fetchMenuOptionsFailure = (error) => ({
  type: FETCH_MENU_OPTIONS_SUCCESS,
  error,
});

export const fetchMenuOptions = () => async (dispatch, getState) => {
  const { topMenu } = getState();
  if (topMenu.fetchedOptions) {
    return;
  }

  dispatch({
    type: FETCH_MENU_OPTIONS,
  });

  try {
    const apiData = await globalSearchApi.getGlobalSearchEntities();

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(
      fetchMenuOptionsSuccess(
        apiData.GlobalSearchEntities.map((entity) => ({
          value: entity.EntityName,
          text: entity.TranslatedEntityName,
        }))
      )
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`fetchMenuOptions() failed: ${JSON.stringify(error)}`);
    dispatch(fetchMenuOptionsFailure(error));
    dispatch(handleErrors(error));
  }
};

export function setSearchText(searchText) {
  return {
    type: SET_SEARCH_TEXT,
    searchText,
  };
}

export function setSearchTextOptions(searchTextOptions) {
  return {
    type: SET_SEARCH_OPTIONS,
    searchTextOptions,
  };
}

export function setClearTextOptions() {
  return {
    type: SET_CLEAR_OPTIONS,
  };
}
